<template>
  <div class="row w-100 p-add-salon-checkbox p-add-salon-checkbox-type-user align-items-center mt-3 mb-4">
        <div class="p-add-salon-checkbox-right">
          <h3 class="p-list-representation-label-text">انواع کاربری</h3>
        </div>

        <div class="row p-add-salon-checkbox-left">
            <label @change='changeCheckBox($event,data)' v-for="data in items" :key="data.id" class="p-add-salon-item">
              <h3 class="p-add-salon-item-text">{{data.title}}</h3>
              <input type="checkbox" :checked="data.checked">
              <span class="checkmark"></span>
            </label>
        </div>
  </div>
</template>

<script>


export default {
    name: 'toolsSalon',
    props: {
      allEnums   : {type:[Object,Array],default:{}},
      formData   : {type:[Object,Array],default:{}},
    },

    data() {
      return {
        items : [

        ]
      }
    },

    computed: {

    },

    mounted () {

    },

    watch: {
      allEnums(data){
        const facilities           = data.facility;
        for (let key in facilities) {
          const dataItem = {
            type    : key,
            title   : facilities[key],
            checked : false,
          }

          this.items = [...this.items,dataItem]
        }

        const splitFacilities= this.formData.facilities.split(',');

        splitFacilities.map((contentForm)=>{
            this.items.map((contentType)=>{
                if (contentType.type == contentForm ) {
                  contentType.checked = true;
                }
            })
        })

        this.$emit('initialConvertArrayFacilities',splitFacilities)
      },

    },

    methods: {
      changeCheckBox($event,data){
        const statusChecked         = $event.target.checked;
        data.checked                = statusChecked;
        let selectedCheckBox        = [];

        this.items.map((t)=>{
          if (t.checked) {
            selectedCheckBox = [...selectedCheckBox,t.type]
          }
        })


        this.$emit("changeCheckBox",data,this.items,selectedCheckBox)
      }

    },

}
</script>
